import React, { useState } from 'react'
import { Col, Container, Modal, Row } from 'react-bootstrap'
import { FaPlay } from 'react-icons/fa'

function Hero() {
    const [show, setShow] = useState(false);
    return (
        <div className='about-hero'>
            <div className='about-gap hero-title'>
                <Container className='text-center d-grid gap-20'>
                    <h1 className='fw-semibold fs-md-35 fs-sm-25 m-0'>About Us</h1>
                    <div className='flex-center-align'>
                        <div className='cs-container-lg d-grid gap-2'>
                            <p className='fs-md-14 fs-sm-12 m-0'>
                                Nexus Paper Packs is a leading manufacturer of Ripple Wall, Double Wall, and Single Wall paper cups. We focus on innovative designs, top-quality production, and sustainable practices to meet your packaging needs.
                            </p>
                            <p className='fs-md-14 fs-sm-12 m-0'>
                                We take pride in our commitment to sustainability and innovation. Our paper cups are designed for both style and functionality, with options like
                            </p>
                        </div>
                    </div>
                </Container>
            </div>
            <div className='hero-video'>
                <Container>
                    <div className='video-holder'>
                        <img src={require('../../assets/images/1ad69f50bb1e2e438e6a99d15a737afc.png')} alt="" />
                        <button onClick={() => setShow(true)} className='play-part'><FaPlay className='fs-35 fs-lg-25 fs-sm-20 ms-1 ms-md-2 mt-md-1' /></button>
                    </div>
                </Container>
            </div>
            <div className='hero-conntent about-gap-reverse'>
                <Container className='text-center d-grid gap-20'>
                    <Row className='text-start gy-2'>
                        <Col className='col-12 col-sm-6 col-lg-4'>
                            <ul className='m-0'>
                                <li className='fs-md-14 fs-sm-12'>Ripple wall cups for temperature maintenance</li>
                            </ul>
                        </Col>
                        <Col className='col-12 col-sm-6 col-lg-4'>
                            <ul className='m-0'>
                                <li className='fs-md-14 fs-sm-12'>Double wall cups for superior insulation </li>
                            </ul>
                        </Col>
                        <Col className='col-12 col-sm-6 col-lg-4'>
                            <ul className='m-0'>
                                <li className='fs-md-14 fs-sm-12'>Single wall cups for versatility</li>
                            </ul>
                        </Col>
                    </Row>
                    <div className='flex-center-align'>
                        <div className='cs-container-lg d-grid gap-2'>
                            <p className='fs-md-14 fs-sm-12 m-0'>
                                We specialize in high-quality, eco-friendly paper cups, including Ripple Wall, Double Wall, and Single Wall options. Our cups are designed for durability, heat retention, and insulation, offering a sustainable choice for various beverage needs. Trust us for all your paper cup packaging needs and join us in creating a greener future.
                            </p>
                            {/* <p className='fs-md-14 fs-sm-12 m-0'>
                                All your paper cup and bagasse-based packaging needs, and join us in our journey towards a greener and more sustainable future.
                            </p> */}
                        </div>
                    </div>
                </Container>
            </div>

            <Modal
                show={show}
                onHide={() => setShow(false)}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='custom-home-video-modal'
            >
                <Modal.Body>
                    <div>
                        <video src={require('../../assets/videos/8164413-uhd_4096_2160_25fps.mp4')} height={"100%"} width={"100%"} autoPlay controls loop></video>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Hero